import httpInstance from './Config'


export default function Get(props){
    if(props.noToken){
        return httpInstance.get(props.url, {        
            headers: {
                'Content-Type': 'application/json',
                "Accept": "application/json",
            }
        })            
    }else{
        return httpInstance.get(props.url, {        
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${props.access_token}`,
                "Accept": "application/json",
            }
        })
    }  

}